// redux/slices/preferenceSlice.js
import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

const PROXY = process.env.REACT_APP_API_URL + "api/preferences";

export const fetchPreferences = createAsyncThunk('preferences/fetch', async (adminId) => {
    const res = await axios.get(`${PROXY}/${adminId}`);
    return res.data.preferences;
});

export const savePreference = createAsyncThunk('preferences/save', async (payload) => {
    const res = await axios.post(`${PROXY}/save`, payload);
    return res.data;
});

export const deletePreference = createAsyncThunk('preferences/delete', async (data) => {
    const res = await axios.delete(`${PROXY}/${data.adminId}/${data.leadType}/${data.type}/${data.index}/${data.name}`);
    return res.data;
});

const preferenceSlice = createSlice({
    name: 'preferences',
    initialState: {
        savedFilters: [],
        savedColumns: [],
        status: {
            fetch: 'idle',
            save: 'idle',
            delete: 'idle'
        },
        error: null
    },
    reducers: {},
    extraReducers: (builder) => {
        builder

            // Fetch Preferences
            .addCase(fetchPreferences.pending, (state) => {
                state.status.fetch = 'loading';
            })
            .addCase(fetchPreferences.fulfilled, (state, action) => {
                state.status.fetch = 'succeeded';
                state.savedFilters = action.payload.savedFilters || {};
                state.savedColumns = action.payload.savedColumns || {};
            })
            .addCase(fetchPreferences.rejected, (state, action) => {
                state.status.fetch = 'failed';
                state.error = action.error.message;
            })

            // Save Preference
            .addCase(savePreference.pending, (state) => {
                state.status.save = 'loading';
            })
            .addCase(savePreference.fulfilled, (state) => {
                state.status.save = 'succeeded';
            })
            .addCase(savePreference.rejected, (state, action) => {
                state.status.save = 'failed';
                state.error = action.error.message;
            })

            // Delete Preference
            .addCase(deletePreference.pending, (state) => {
                state.status.delete = 'loading';
            })
            .addCase(deletePreference.fulfilled, (state) => {
                state.status.delete = 'succeeded';
            })
            .addCase(deletePreference.rejected, (state, action) => {
                state.status.delete = 'failed';
                state.error = action.error.message;
            });
    }
});

export default preferenceSlice.reducer;